import {useEffect} from 'react';
import {useOrderStore} from '../../store/orderStore';
import {useAuthStore} from '../../store/authStore';
import {AuthError} from '../../errors/authError';

interface OrderProviderProps {
    children: JSX.Element;
}

const OrderProvider = ({children}: OrderProviderProps) => {
    const {order, fetchOrder} = useOrderStore(state => state);
    const {bearer, setInvalidBearer} = useAuthStore(state => state);

    useEffect(() => {
        if (!bearer || order) {
            return;
        }

        const abortController = new AbortController();

        void fetchOrder(bearer).catch((e: AuthError) => {
            setInvalidBearer(e.type);
        });

        return () => {
            abortController.abort();
        };
    }, [bearer, order, fetchOrder, setInvalidBearer]);

    return children;
};

export default OrderProvider;
